<template>
  <a href="#"
     ref="myedit"
     data-type="text"
  >{{val}}</a>
</template>
<script>
export default
{
  props:{
    value:{
      type:String,
      default:''
    },
  },
  watch:{
    value:function () {

      if(this.val != this.value) {

        // ui 를 다시그린다.
        var v = this.$refs.myedit
        $(v).editable('setValue', this.value, true);
      }
      this.val = this.value
    }
  },
  data: () => ({
    val:'',
  }),
  created() {
  },
  methods:{
    init:function () {

      //console.log('init!! ' + this.value)

      this.val = this.value
      var that = this

      var v = this.$refs.myedit
      $(v).editable({
        type: 'text',
        name: '',
        defaultValue:that.val,
        title: '',
        mode: 'inline',
        inputclass: 'form-control-sm',
        success: function(response, newValue) {
          that.$emit('input', newValue)
          that.$emit('change')
          //return newValue
        }
      })
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style>
button.editable-submit {
  font-size: 16px;
  line-height: 16px;
  width: 40px;
}
button.editable-cancel:hover {
  color: white !important;
  background-color: #d20000;
}
button.editable-cancel {
  font-size: 16px;
  line-height: 16px;
  width: 40px;
  background-color: #e00000;
  color: white;
}
</style>